import styled from 'styled-components';
import { SensorChart } from '../../molecules';

export const Chart = styled(SensorChart)`
  height: 100%;
  width: 100%;
`;
